/**
 * Adapted from the MIT licensed `stylis-plugin-rtl` package.
 * The original implementation can be found at
 * https://github.com/styled-components/stylis-plugin-rtl.
 */
import cssjanus from "cssjanus/src/cssjanus";
import {
  COMMENT,
  DECLARATION,
  IMPORT,
  KEYFRAMES,
  MEDIA,
  RULESET,
  SUPPORTS,
  compile,
  serialize,
  strlen,
} from "stylis";

function stringifyPreserveComments(element) {
  switch (element.type) {
    case IMPORT:
    case DECLARATION:
    case COMMENT:
      element.return = element.return || element.value;
      return element.return;
    case RULESET: {
      element.value = Array.isArray(element.props)
        ? element.props.join(",")
        : element.props;

      if (Array.isArray(element.children)) {
        element.children.forEach((child) => {
          if (child.type === COMMENT) {
            child.children = child.value;
          }
        });
      }

      break;
    }
    default:
      break;
  }

  const serializedChildren = serialize(
    Array.prototype.concat(element.children),
    stringifyPreserveComments
  );

  return strlen(serializedChildren)
    ? (element.return = `${element.value}{${serializedChildren}}`)
    : "";
}

const rtlPlugin = (element, index, children) => {
  if (
    element.type === KEYFRAMES ||
    element.type === SUPPORTS ||
    (element.type === RULESET &&
      (!element.parent ||
        element.parent.type === MEDIA ||
        element.parent.type === RULESET))
  ) {
    const stringified = cssjanus.transform(
      stringifyPreserveComments(element, index, children)
    );

    element.children = stringified ? compile(stringified)[0].children : [];
    element.return = "";
  }
};

Object.defineProperty(rtlPlugin, "name", { value: "stylisRTLPlugin" });

export default rtlPlugin;
